var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-success"},[_c('i',{staticClass:"main-icon icon ion-md-checkmark"}),_c('p',{staticClass:"main-text"},[_vm._v("פנייתך תקרא בתשומת לב ותיענה במידת הצורך")]),_c('button',{staticClass:"yes theme-button-outline",on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v(" חזרה למשחקים ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }